var jade = require("/home/circleci/rentapplication-frontend/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div ng-if=\"warning.visible &amp;&amp; displayMessage\" class=\"freeform-warning\"><p ng-class=\"{'datesplit-label': warning.datesplit }\" class=\"warning\">{{warning.text}}</p><a ng-click=\"close($event, 'confirm')\" ng-class=\"{'datesplit-confirm': warning.datesplit }\" class=\"btn btn-success\">{{confirmtext}}</a><a ng-click=\"close($event, 'discard')\" ng-if=\"discardtext\" class=\"btn btn-warning\">{{discardtext}}</a></div>");;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./directives/freeforms/warning/warning.jade
// module id = 420
// module chunks = 0